'use client'

import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import * as React from 'react'

import { cn } from '../../lib'

type Props = React.ComponentProps<typeof CheckboxPrimitive.Root>

const Checkbox = ({ className, ...props }: Props) => {
  const checkboxStyles = cn(
    // 기본 스타일
    'peer shrink-0 w-6 h-6 relative overflow-hidden',

    // 상태별 스타일
    'data-[state=unchecked]:text-gray-200',
    'data-[state=checked]:text-primary',
    'data-[state=checked]:border-gray-900',

    // 포커스 및 비활성화 스타일
    'focus-visible:outline-none',
    'focus-visible:ring-1',
    'focus-visible:ring-ring',
    'disabled:cursor-not-allowed',
    'disabled:opacity-50',

    className,
  )

  return (
    <CheckboxPrimitive.Root className={checkboxStyles} {...props}>
      <CheckboxPrimitive.CheckboxIndicator forceMount className="left-0 top-0 absolute rounded-full">
        {props.checked ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" fill="#ECECEC" />
            <g id="CONTROL">
              <rect width="488" height="703" transform="translate(-264 -200)" fill="white" />
              <g id="Frame 1410135330">
                <g id="Frame 1410135328">
                  <g id="icon-fill-24px-check-circle">
                    <circle id="Ellipse 1814" cx="12" cy="12" r="10.5" fill="#B5FD4C" stroke="#1C1C1C" />
                    <path
                      id="Vector 2671"
                      d="M8 12.5L10.4749 14.9749L16.1317 9.31802"
                      stroke="#1C1C1C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        ) : (
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="11" cy="11" r="11" fill="#D6D6D6" />
            <g clipPath="url(#clip0_16036_5660)">
              <path
                d="M14.8369 7.17188C15.141 6.92381 15.5896 6.94209 15.873 7.22559L15.9268 7.28418C16.1579 7.56801 16.1579 7.97793 15.9268 8.26172L15.873 8.32031L10.1016 14.0938C9.90329 14.2924 9.64305 14.4149 9.36621 14.4424L9.24609 14.4482C8.92532 14.4483 8.61724 14.3209 8.39062 14.0938V14.0928L6.12695 11.8291H6.12598C5.82394 11.5267 5.82386 11.0358 6.12598 10.7334H6.12695L6.18555 10.6807C6.48962 10.4327 6.93828 10.45 7.22168 10.7334L9.24609 12.7598L14.7783 7.22559L14.8369 7.17188Z"
                fill="white"
                stroke="white"
                strokeWidth="0.3"
              />
            </g>
            <defs>
              <clipPath id="clip0_16036_5660">
                <rect width="11" height="11" fill="white" transform="translate(5.5 5.5)" />
              </clipPath>
            </defs>
          </svg>
        )}
      </CheckboxPrimitive.CheckboxIndicator>
    </CheckboxPrimitive.Root>
  )
}

Checkbox.displayName = CheckboxPrimitive.Root.displayName

export default Checkbox
